import React from 'react';
import Text from 'components/base/Text';
import { Flex } from 'components/base/layout-components';

export default function SnackBarMessage({ message }) {
  return (
    <Flex direction='column'>
      <Text size='large' color='white'>
        {message}
      </Text>
    </Flex>
  );
}
